import { Card } from "react-bootstrap";
import MainNavbar from "../components/reuse/navbar";
import "../styles/personal/settings_page.css";

const developerSettings = [
  { key: "mapLoadDetails", label: "Загрузка карты", description: "Прогресс, число объектов и время ответа API." },
  { key: "factorLoadDetails", label: "Загрузка факторов", description: "Источник и число загруженных гексов по каждому из четырёх наборов." },
  { key: "mapTechnicalData", label: "Технические данные карты", description: "Исходные поля, служебные типы дорог и выгрузки выбранных объектов." },
  { key: "factorTechnicalData", label: "Детали факторной модели", description: "Технические пояснения в анализе факторов." },
  { key: "reportDetails", label: "Данные отчётов", description: "Имена файлов и число строк при загрузке графиков." },
];

export default function SettingsPage() {
  const language = window.CODD_MAP_CONFIG?.lang === "dev" ? "dev" : "rus";
  const showDeveloperData = window.CODD_MAP_CONFIG?.showDeveloperData === true;
  const developerDataOptions = window.CODD_MAP_CONFIG?.developerDataOptions || {};

  return (
    <>
      <MainNavbar />
      <main className="container settings-page">
        <h1>Настройки</h1>
        <Card className="settings-page-card">
          <Card.Body>
            <h2>Отображение карты</h2>
            <fieldset className="settings-page-language">
              <legend>Язык подписей</legend>
              <div className="settings-page-language-options">
                <label className="settings-page-language-option">
                  <input type="radio" name="settingsPageLanguage" value="rus" defaultChecked={language === "rus"} onChange={() => window.setCoddMapDisplayPreferences?.({ lang: "rus" })} />
                  <img src="/map_runtime/icons/lang/rus.svg" alt="" aria-hidden="true" />
                  <span>Русский</span>
                </label>
                <label className="settings-page-language-option">
                  <input type="radio" name="settingsPageLanguage" value="dev" defaultChecked={language === "dev"} onChange={() => window.setCoddMapDisplayPreferences?.({ lang: "dev" })} />
                  <img src="/map_runtime/icons/lang/dev.svg" alt="" aria-hidden="true" />
                  <span>Dev</span>
                </label>
              </div>
            </fieldset>
            <label className="settings-page-developer-option">
              <input type="checkbox" defaultChecked={showDeveloperData} onChange={(event) => window.setCoddMapDisplayPreferences?.({ showDeveloperData: event.target.checked })} />
              <span>Режим разработчика</span>
            </label>
            <div className="settings-page-developer-options" aria-label="Параметры режима разработчика">
              {developerSettings.map(({ key, label, description }) => (
                <label key={key} className="settings-page-developer-detail">
                  <input
                    type="checkbox"
                    disabled={!showDeveloperData}
                    defaultChecked={developerDataOptions[key] !== false}
                    onChange={(event) => window.setCoddMapDisplayPreferences?.({ developerDataOptions: { [key]: event.target.checked } })}
                  />
                  <span><strong>{label}</strong><small>{description}</small></span>
                </label>
              ))}
            </div>
            <p className="settings-page-note">Изменения сохраняются в этом браузере. Страница перезагрузится, чтобы применить их ко всем картам.</p>
          </Card.Body>
        </Card>
      </main>
    </>
  );
}
